let locales = {};

import keyFob from "../../keyFobsTab/lan/en";
import crew from "../../crewTab/lan/en";
import equipment from "../../equipmentTab/lan/en";
import fuelCard from "../../fuelCardTab/lan/en";
import temperature from "../../temperatureTab/lan/en";
import driverStatus from "../../driverStatusTab/lan/en";
import locations from "../../locationsTab/lan/en";
import behavior from "../../behaviorTab/lan/en";
import inputs from "../../inputsTab/lan/en";
import cameraManagement from "../../cameraManagementTab/lan/en";
import vehicleStatus from "../../vehicleStatusTab/lan/en";

locales = { ...keyFob, ...crew, ...equipment, ...fuelCard, ...temperature, ...driverStatus, ...locations, ...inputs, ...cameraManagement, ...behavior, ...vehicleStatus };

export default locales;
